<template>
	<div class="IndexBox" style="background: url('./static/images/profile-bg.png');background-size: 100% 100%;height: 100%;width: 100%;">
	  <div class="ScrollBox">
		  <van-nav-bar
		    fixed
		    :border="false"
		    :title="$t('user.office[4]')"
		    left-arrow
		    @click-left="$router.go(-1)"
		  />
		<div style="padding-top:20%;text-align: center;">
			<div style="background: rgb(255, 255, 255); border-radius: 25px; margin: 10px;height:300px">
				<div style="padding:1rem 0 5% 0.3125rem;text-align: left;">{{$t('user.office[6]')}} ({{reData.post['name'] ? reData.post['name'] : 'BWM Staff'}}) :</div>
				<div style="padding:0 0 5% 0.3125rem;text-align: left;">{{$t('user.office[7]')}} ({{reData.post['num3']}}){{$t('user.office[9]',{name:reData.post['p_name'] ? reData.post['p_name'] : reData.post['name']})}}</div>
				<div style="display: flex;width: 100%;padding: 0 10%;">
					<div v-for="(star, index) in 5" :key="index" @click="rate($event, index + 1)" >
					<img v-if="rating >= index + 1" src="../images/full1.svg" alt="Full Star" style="width: 3.75rem;height: 3.75rem;">
					<img v-else src="../images/full.svg" alt="Empty Star" style="width: 3.75rem;height:3.75rem;">
					</div>
				</div>
				<div style="margin-top: 1rem;padding:0 0 0 0.3125rem;text-align: left;">{{$t('user.office[10]')}} ({{reData.post['num2']}}){{$t('user.office[11]')}}</div>
				<div style="padding: 5% 0 5% 0;">
					<van-progress strokeWidth="10" :pivotText="getStr()" color="#03A9F4" :percentage="schedule" style="width: 95%;margin:0 auto;" />
				</div>
				<div style="width:90%;margin:0 auto;padding:10px;text-align: center; background: #37774C;color: #fff;" @click="openShow()">
				{{$t('user.office[5]')}}
				</div>
			</div>
			
		  </div>
		  
		  
		</div>
	</div> 
</template>

<script>
export default {
	name:"Job Promotion",
	data(){
		return {
			rating: 0,
			showCon: false,
			infoData:'',
			reData:[],
			schedule:100
		}
	},
	computed: {
	},
	watch: {
	},
	created() {
		this.$Model.GetUserInfo();
		this.$parent.navBarTitle = this.$t("user.office[4]")
		this.$Model.GetJobStatus(data=>{

		  if(data.code==1){
		    
			this.reData = data.data;
			
		  }
		})
		
	},
	mounted() {
	},
	activated() {},
	destroyed() {},
	methods: {
		rate(event, newRating) {
		      this.rating = newRating;
		    },
		getStr(n1,n2) {
			
			this.schedule = this.reData['schedule'];
			this.rating = this.reData['star'];
			return this.reData['numberMembers']+"/"+this.reData['satisfy'];
		},
		openShow(data) {
			
			if(this.reData['star'] < 5){
				return this.$Dialog.Toast(this.$t("user.office[8]"));
			}
			
		  if(this.reData['schedule'] != 100 ){
			  this.$Dialog.Toast(this.$t("user.office[8]"));
		  }else{
			  this.$Model.Apply(data=>{
			  	if(data.code==1){
			  		this.$Dialog.Toast(data.msg);
			  		
			  	}
			  });
		  }
		  
		}
	}
}
	
</script>

<style scoped>
	.van-progress__pivot{font-size: 14px;}
span{text-wrap-mode:wrap;}
</style>